import {
    Button,
    Flex,
    FormControl,
    FormErrorMessage,
    ModalBody,
    ModalFooter,
} from '@chakra-ui/react';
import { Controller, useFormContext } from 'react-hook-form';
import { BookableServiceV2 } from '@acp/shared';
import { PropertyAddressCard } from '../../../property/components/property-address-card';
import { SubmitBookingFormSchemaValues } from './form-scheme';
import { BookingServiceSelectStatic } from './booking-service-select';
import { AvailableBookingTimes } from './available-booking-times';
import { useBookableServiceOptions } from '../../hooks/use-bookable-service-options';

export function ChooseBookingTimeScreen({
    propertyId,
    onClose,
    onSubmit,
    handleResetTime,
    enableCloseButton = true,
    overrideBookableServices = null,
}: {
    propertyId: number;
    onClose: () => void;
    onSubmit: () => void;
    handleResetTime: () => void;
    enableCloseButton?: boolean;
    overrideBookableServices: BookableServiceV2[] | null;
}) {
    const { control } = useFormContext<SubmitBookingFormSchemaValues>();

    const {
        isLoading,
        serviceOptions,
    } = useBookableServiceOptions(
        propertyId,
        overrideBookableServices
    );

    const hasService = serviceOptions?.length > 0;

    return (
        <>
            <ModalBody>
                <PropertyAddressCard w="full" mb={5} propertyId={propertyId} />

                {/* bookable services */}
                <Flex alignItems="center" w="full" mb={6}>
                    <Controller
                        control={control}
                        name="oasBooking.bookingTypes"
                        render={({ field, fieldState }) => (
                            <FormControl
                                isInvalid={fieldState.invalid}
                                isRequired
                                mb={2}
                            >
                                <BookingServiceSelectStatic
                                    serviceOptions={serviceOptions}
                                    value={field.value}
                                    onChange={(service) => {
                                        field.onChange(service?.value);
                                    }}
                                    isLoading={isLoading}
                                />
                                {fieldState.error && (
                                    <FormErrorMessage>
                                        {fieldState.error.message}
                                    </FormErrorMessage>
                                )}
                            </FormControl>
                        )}
                    />
                </Flex>

                {/* booking slots */}
                {!isLoading && hasService && (
                    <AvailableBookingTimes
                        propertyId={propertyId}
                        onChooseTimeSlot={onSubmit}
                        handleResetTime={handleResetTime}
                    />
                )}
            </ModalBody>

            <ModalFooter justifyContent="space-between">
                {
                    enableCloseButton && (
                        <Button
                            colorScheme="muted"
                            size="md"
                            variant="ghost"
                            onClick={onClose}
                        >
                            Close
                        </Button>
                    )
                }
            </ModalFooter>
        </>
    );
}
